import * as React from 'react';
import { clsx } from 'clsx';
import { IconActionChevronLeft24, IconActionChevronRight24 } from '@cian/ui-kit-design-tokens/icons';

import * as styles from '../../styles/button.css';

interface IButtonProps {
  right?: boolean;
  onClick(e: React.MouseEvent): void;
}

export const ScrollButton: React.FC<IButtonProps> = ({ onClick, right }) => {
  return (
    <button
      className={clsx(styles['button'], right ? styles['button-right'] : styles['button-left'])}
      onClick={onClick}
      tabIndex={-1}
    >
      {right ? <IconActionChevronRight24 /> : <IconActionChevronLeft24 />}
    </button>
  );
};
